__turbopack_context__.v({
  "tableRoot": "Table-module-scss-module__9u4w7q__tableRoot",
  "tableScrollOnMobile": "Table-module-scss-module__9u4w7q__tableScrollOnMobile",
});
